import React from "react";
import { Box } from "app/layout/Box/Box";

import "./style.scss";

export interface Props {
    title: string;
    text: string;
}

export const FinanceKnowledge = ({ title, text }: Props) => {
    const classNames = ["financeKnowledge"];
    const [isCollapsed, setIsCollapsed] = React.useState(true);

    if (!isCollapsed) {
        classNames.push("open");
    }

    return (
        <Box alternateBackground className={classNames.join(" ")} onClick={() => setIsCollapsed(!isCollapsed)}>
            <strong>Finanzwissen</strong>
            <h3>{title}</h3>
            <p>{text}</p>
        </Box>
    );
};
